// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"theaters"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M7.5 3L7.5 21H3L3 3L7.5 3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M20.75 3L20.75 21H16.25L16.25 3L20.75 3Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 21L3 3M3 21H21M3 21H7.5L7.5 3L3 3M3 3L21 3M21 3V21M21 3L16.5 3V21H21M3 7.5L8 7.5M3 12H8M3 16.5H8M16 7.5L21 7.5M16 12H21M16 16.5H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TheatersIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'theaters',
    ref,
    icon: element,
  },
));

TheatersIcon.displayName = 'TheatersIcon';

export default TheatersIcon;
